import React from "react";
import styled from "styled-components";
import AboutNmdfcContent from "./AboutNmdfcContent";
import VisionMissionContent from "./VisionMissionContent";
import BoardOfDirectorsContent from "./BoardOfDirectorsContent";
import OurTeamContent from "./OurTeamContent";
import OrganizationChartContent from "./OrganizationChartContent";
import CapitalStructureContent from "./CapitalStructureContent";
import ScasPartnersContent from "./ScasPartnersContent";
import TargetGroupsContent from "./TargetGroupsContent";
import GalleryContent from "./GalleryContent";

const ContentContainer = styled.div`
  flex: 1;
  min-width: 0;
  background-color: transparent;
  padding: 0;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const WelcomeTitle = styled.h2`
  color: #1a4d5c;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 15px;
`;

const SectionTitle = styled.h2`
  color: #1a4d5c;
  font-size: 17px;
  font-weight: 700;
  margin-bottom: 12px;
  margin-top: 20px;
`;

const Paragraph = styled.p`
  color: #333333;
  font-size: 13px;
  line-height: 1.7;
  margin-bottom: 12px;
  text-align: justify;
`;

const BulletList = styled.ul`
  list-style-type: none;
  padding-left: 0;
  margin-bottom: 15px;
  margin-top: 10px;
`;

const BulletItem = styled.li`
  color: #333333;
  font-size: 13px;
  line-height: 1.7;
  margin-bottom: 8px;
  padding-left: 24px;
  position: relative;

  &:before {
    content: "\\2022";
    color: #1a4d5c;
    font-weight: bold;
    position: absolute;
    left: 0;
  }

  strong {
    color: #1a4d5c;
    font-weight: 700;
  }
`;

const HighlightBox = styled.div`
  background-color: transparent;
  padding: 0;
  margin: 15px 0;
  border-radius: 4px;
`;

const HighlightTitle = styled.h2`
  color: #1a4d5c;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 8px;
`;

const HighlightText = styled.p`
  color: #333333;
  font-size: 13px;
  line-height: 1.7;
  margin: 0;
`;

const Link = styled.a`
  color: #006b8f;
  text-decoration: none;
  cursor: pointer;
  font-weight: 600;

  &:hover {
    text-decoration: underline;
  }
`;

const AboutContent = ({ activeSection }) => {
  const renderContent = () => {
    switch (activeSection) {
      case "about-nmdfc":
        return <AboutNmdfcContent />;

      case "vision-mission":
        return <VisionMissionContent />;

      case "board-directors":
        return <BoardOfDirectorsContent />;

      case "our-team":
        return <OurTeamContent />;

      case "organization-chart":
        return <OrganizationChartContent />;

      case "capital-structure":
        return <CapitalStructureContent />;

      case "scas-partners":
        return <ScasPartnersContent />;

      case "target-groups":
        return <TargetGroupsContent />;

      case "events":
        return <GalleryContent />;

      default:
        return null;
    }
  };

  return <ContentContainer>{renderContent()}</ContentContainer>;
};

export default AboutContent;
